var GeoStatus;
(function (GeoStatus) {
    GeoStatus["granted"] = "granted";
    GeoStatus["notDetermined"] = "notDetermined";
    GeoStatus["denied"] = "denied";
})(GeoStatus || (GeoStatus = {}));
var GeoStatus$1 = GeoStatus;

var BarcodeFormat;
(function (BarcodeFormat) {
    BarcodeFormat["EAN_13"] = "ean_13";
    BarcodeFormat["EAN_8"] = "ean_8";
    BarcodeFormat["CODE_128"] = "code_128";
    BarcodeFormat["CODE_39"] = "code_39";
    BarcodeFormat["CODE_93"] = "code_93";
    BarcodeFormat["ITF"] = "itf";
    BarcodeFormat["UPC_A"] = "upc_a";
    BarcodeFormat["UPC_E"] = "upc_e";
})(BarcodeFormat || (BarcodeFormat = {}));
var BarcodeFormat$1 = BarcodeFormat;

var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["granted"] = "granted";
    NotificationStatus["notDetermined"] = "notDetermined";
    NotificationStatus["denied"] = "denied";
})(NotificationStatus || (NotificationStatus = {}));
var NotificationStatus$1 = NotificationStatus;

const shareFile = (base64, filename = 'name', mime = 'image/png') => {
    var _a;
    if (window.RahmetApp.loadBase64File) {
        (_a = window.RahmetApp) === null || _a === void 0 ? void 0 : _a.loadBase64File(JSON.stringify({ base64, filename, mime }));
    }
};

const shareImage = (base64, filename = 'name', mime = 'image/png') => {
    if (window.RahmetApp.shareImage) {
        window.RahmetApp.shareImage(JSON.stringify({ base64, filename, mime }));
    }
};

const shareText = (text) => {
    if (window.RahmetApp.shareText) {
        window.RahmetApp.shareText(text);
    }
};

const hapticSelection = () => {
    if (!window.RahmetApp.hapticSelection) {
        return;
    }
    return window.RahmetApp.hapticSelection();
};

const ERROR_MESSAGE = 'NOT_SUPPORTED';

const connect = (callback) => {
    return new Promise((resolve, reject) => {
        try {
            callback(resolve);
        }
        catch (error) {
            reject(error);
        }
    });
};

const getRefferalCode = () => {
    return connect((resolve) => {
        window.RahmetApp.getReferralCode();
        window.RahmetWebApp.didGetReferralCode = code => resolve(JSON.parse(code));
    });
};

const backHandlersStack = [];
const whenNavigationToBack = (cb) => {
    backHandlersStack.push(cb);
};
const cancelHandlingToBack = () => {
    backHandlersStack.pop();
};
const handleNavigationToBack = () => {
    window.RahmetWebApp.onBackPressed = function () {
        const responseToNative = backHandlersStack.length > 0;
        if (responseToNative) {
            const cb = backHandlersStack[backHandlersStack.length - 1];
            cb();
        }
        return responseToNative;
    };
};

const clearCache = () => {
    if (window.RahmetApp.clearCache) {
        window.RahmetApp.clearCache();
    }
};

const onKeyboardClosed = (callback) => {
    window.RahmetWebApp.onKeyboardClosed = callback;
};

const getNotificationStatus = () => {
    return connect((resolve) => {
        if (typeof window.RahmetApp.getNotificationStatus === 'function') {
            window.RahmetApp.getNotificationStatus();
            window.RahmetWebApp.didGetIsNotificationStatus = (status) => resolve(status);
        }
        else {
            resolve(NotificationStatus$1.notDetermined);
        }
    });
};
const requestNotificationStatus = () => {
    return connect((resolve) => {
        if (typeof window.RahmetApp.requestNotificationStatus === 'function') {
            window.RahmetApp.requestNotificationStatus();
            window.RahmetWebApp.didGetIsNotificationStatus = (status) => resolve(status);
        }
        else {
            resolve(NotificationStatus$1.notDetermined);
        }
    });
};

const isNotifyBody = (value) => {
    if (value && typeof value === 'object' && 'type' in value) {
        return true;
    }
    return false;
};
const isNotifyType = (value) => {
    return typeof value === 'string' && ['success', 'info', 'warning', 'error'].includes(value);
};
function toastNotify(body, title = '', message = '') {
    if (!window.RahmetApp.showNativeNotification) {
        throw new Error(ERROR_MESSAGE);
    }
    let type = 'success';
    let _title = '';
    let _message = '';
    if (isNotifyBody(body)) {
        type = body.type || 'success';
        _title = body.title || '';
        _message = body.message || '';
    }
    else {
        if (isNotifyType(body)) {
            type = body;
        }
        _title = title;
        _message = message;
    }
    return window.RahmetApp.showNativeNotification(JSON.stringify({
        type,
        title: _title,
        message: _message
    }));
}

const openAppSettings = () => {
    if (window.RahmetApp.openAppSettings)
        window.RahmetApp.openAppSettings();
};

const authorize = (clientId, type, redirectUri = window.location.href, state = '') => {
    return connect((resolve) => {
        if (type === 'code') {
            if (!window.RahmetApp.authorizeV2) {
                throw new Error(ERROR_MESSAGE);
            }
            window.RahmetApp.authorizeV2(JSON.stringify({
                client_id: clientId,
                response_type: 'code',
                redirect_uri: redirectUri,
                state
            }));
            window.RahmetWebApp.onAuthSuccessV2 = (code) => resolve(code);
        }
        else {
            window.RahmetApp.authorize();
            window.RahmetWebApp.onAuthSuccess = (trackId) => resolve(trackId);
        }
        window.RahmetWebApp.onAuthDismissed = () => resolve(undefined);
        window.RahmetWebApp.onAuthError = (code, message) => {
            if (message) {
                throw new Error(message);
            }
            resolve(undefined);
        };
    });
};

const backToApplication = () => {
    window.RahmetApp.backToRahmetApp();
};

const applicationBecomeActive = (callback) => {
    window.RahmetWebApp.didBecomeActive = callback;
};

const isLocationEnabled = () => {
    if (window.RahmetApp.isLocationEnabled) {
        return window.RahmetApp.isLocationEnabled();
    }
    return true;
};

const openQR = () => {
    return connect((resolve) => {
        if (!window.RahmetApp.openQRScannerWithTextResult) {
            return resolve('');
        }
        window.RahmetApp.openQRScannerWithTextResult();
        window.RahmetWebApp.didScanQrText = text => resolve(text);
    });
};

const pay = (deeplink) => {
    return connect((resolve) => {
        window.RahmetApp.pay(deeplink);
        window.RahmetWebApp.onPaySuccess = () => resolve('success');
        window.RahmetWebApp.onNativePayViewClosed = () => resolve('closed');
    });
};

const requestGeoPermissionStatus = () => {
    return connect((resolve) => {
        window.RahmetApp.requestGeoPermissionStatus();
        window.RahmetWebApp.onGeoPermissionStatusDefined = (status) => resolve(status);
    });
};

/**
 * При успешном сканировании возвращает строку с штрихкодом.
 * При нажатии на ручной ввод возвращает строку 'manual'.
 */
const openBarcodeScanner = (formats = [BarcodeFormat$1.EAN_8, BarcodeFormat$1.EAN_13, BarcodeFormat$1.CODE_128], instructions = [], actionText) => {
    return connect((resolve) => {
        if (!window.RahmetApp.openBarcodeScanner) {
            return resolve('manual');
        }
        window.RahmetApp.openBarcodeScanner(JSON.stringify({ formats, instructions, actionText }));
        window.RahmetWebApp.onBarcodeScannerSuccess = barcode => resolve(barcode);
        window.RahmetWebApp.onTapBarcodeEnter = () => resolve('manual');
    });
};

const isCameraPermissionEnabled = () => {
    return connect((resolve) => {
        if (!window.RahmetApp.isCameraPermissionEnabled) {
            return resolve(false);
        }
        window.RahmetApp.isCameraPermissionEnabled();
        window.RahmetWebApp.onCameraPermissionStatusDefined = status => resolve(status);
    });
};

const logAmplitudeEvent = (event, body) => {
    if (!window.RahmetApp.logAmplitudeEvent) {
        return false;
    }
    window.RahmetApp.logAmplitudeEvent(JSON.stringify({
        event,
        body
    }));
    return true;
};

const logAppsflyerEvent = (event, body = {}) => {
    if (!window.RahmetApp.logAppsflyerEvent) {
        return false;
    }
    window.RahmetApp.logAppsflyerEvent(JSON.stringify({
        event,
        body
    }));
    return true;
};

if (!window.RahmetWebApp) {
    window.RahmetWebApp = {
        onAuthSuccess: () => { },
        onAuthSuccessV2: () => { },
        onAuthDismissed: () => { },
        onAuthError: () => { },
        onPaySuccess: () => { },
        onNativePayViewClosed: () => { },
        onGeoPermissionStatusDefined: () => { },
        didBecomeActive: () => { },
        onBackPressed: () => false,
        didScanQrText: () => { },
        didGetReferralCode: () => { },
        onKeyboardClosed: () => { },
        onCameraPermissionStatusDefined: () => { },
        onBarcodeScannerSuccess: () => { },
        onTapBarcodeEnter: () => { },
        didGetIsNotificationStatus: () => NotificationStatus$1.notDetermined,
        onCardAdded: () => { }
    };
}

export { BarcodeFormat$1 as BarcodeFormat, GeoStatus$1 as GeoStatus, NotificationStatus$1 as NotificationStatus, applicationBecomeActive, authorize, backToApplication, cancelHandlingToBack, clearCache, getNotificationStatus, getRefferalCode, handleNavigationToBack, hapticSelection, isCameraPermissionEnabled, isLocationEnabled, logAmplitudeEvent, logAppsflyerEvent, onKeyboardClosed, openAppSettings, openBarcodeScanner, openQR, pay, requestGeoPermissionStatus, requestNotificationStatus, shareFile, shareImage, shareText, toastNotify, whenNavigationToBack };
//# sourceMappingURL=index.js.map
